import FAQ from '@/components/faq/FAQ';
import React from 'react';

export default function _Examples() {
  return <FAQ />;
}
